<template>
  <transition name="slide-fade">
    <v-container fluid>
      <form @submit.prevent="RegisterUClient(client)">
        <fieldset>
          <legend>Personal Details (required)</legend>
          <v-text-field label="Name" v-model="client.name" required="required" :error-messages="_error('name', 'createClientUser')" placeholder="Enter your full name"></v-text-field>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 class="pr-1">
              <date-picker label="Date of Birth" v-model="client.date_of_birth" required="required" :error-messages="_error('date_of_birth', 'createClientUser')" type="date" placeholder="Please enter your date of birth"></date-picker>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-select label="Gender" v-model="client.gender" required="required" placeholder="Please Choose" :error-messages="_error('gender', 'createClientUser')" :items="[ 'Female', 'Male' ]"></v-select>
            </v-flex>
          </v-layout>
        </fieldset>
        <fieldset>
          <legend>Contact Information (required)</legend>
          <v-text-field label="Phone Number" v-model="client.phone" required="required" placeholder="+254722......" :error-messages="_error('phone', 'createClientUser')"></v-text-field>
          <v-text-field label="Email" v-model="client.email" required="required" placeholder="Enter your email address" :error-messages="_error('email', 'createClientUser')" type="email" hint="You will use this to login to your account" v-if="!$user"></v-text-field>
          <v-text-field label="Residence Location" v-model="client.location" required="required" placeholder="Where do you reside?" hint="This information will help the medical practitioner reach you" :error-messages="_error('location', 'createClientUser')"></v-text-field>
        </fieldset>
        <fieldset>
          <legend>Additional Information (optional)</legend>
          <v-text-field label="Known Allergies" v-model="client.allergies" placeholder="Do you have known allergies?" :error-messages="_error('allergies', 'createClientUser')"></v-text-field>
          <v-text-field label="Next of Kin Name" v-model="client.next_of_kin_name" placeholder="Next of Kin Name" :error-messages="_error('next_of_kin_name', 'createClientUser')" hint="Enter the name of a person to call incase of emergency"></v-text-field>
          <v-text-field label="Next of Kin Phone" v-model="client.next_of_kin_phone" placeholder="+254722......" :error-messages="_error('next_of_kin_name', 'createClientUser')" hint="Enter the number to call incase of emergency"></v-text-field>
        </fieldset>
        <fieldset v-if="!$user">
          <legend>Account Details</legend>
          <v-text-field label="Username" v-model="client.username" placeholder="Enter username" hint="You can this username or email to login to your account" :error-messages="_error('username', 'createClientUser')"></v-text-field>
          <v-text-field label="Password" type="password" v-model="client.password" required="required" :error-messages="_error('password', 'createClientUser')"></v-text-field>
          <v-text-field label="Confirm Password" type="password" v-model="client.password_confirmation" required="required" :error-messages="_error('password_confirmation', 'createClientUser')"></v-text-field>
          <check-code v-model="client.referral_code" :errors="errors"></check-code>
          <v-checkbox v-model="client.terms_accepted" required :rules="[form_rules.required]" :error-messages="_error('terms_accepted', 'createNewUser')">
            <template #label>
              <p>I have read and accepted the &nbsp;<inertia-link href="/terms-of-use">Terms of Use</inertia-link>&nbsp; and the &nbsp;<inertia-link href="/privacy-policy">Privacy Policy</inertia-link>.</p>
            </template>
          </v-checkbox>
        </fieldset><br>
        <v-btn small type="submit" class="primary pull-right" :loading="client.processing">Save</v-btn><br>
      </form>
    </v-container>
  </transition>
</template>

<script>
  // import layout from '@/Layouts/MainLayout'
  const DatePicker = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/datepicker.vue')
  const CheckCode = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/Referral/CheckCode.vue')

  export default {
    name: 'RegisterClient',
    //layout,
    props: [
      'errors',
    ],
    components: {
      DatePicker,
      CheckCode,
    },
    data () {
      return {
        client: this.$inertia.form({
          '_METHOD': 'POST',
          name: '',
          gender: '',
          date_of_birth: '',
          location: '',
          phone: '',
          email: '',
          allergies: '',
          next_of_kin_name: '',
          next_of_kin_phone: '',
          username: '',
          password: '',
          password_confirmation: '',
          terms_accepted: false,
          referral_code: '',
        }, {
          bag: 'createClientUser'
        })
      }
    },
    methods: {
      RegisterUClient (client) {
        this.client.post(route('user.client.store'))
      },
    },
  }
</script>
